import type { OrganizationState, State } from 'src/store/types';
import { createSelector } from '@reduxjs/toolkit';
import { getOrganization } from './organization/getOrganization';

/**
 * Returns tutorials from Redux store (fetched from API)
 * Legacy function for backwards compatibility
 * @deprecated Use the memoized selector `tutorialsForOrganizationSelector` instead
 */
export function tutorialsForOrganization(organization: OrganizationState) {
  // Return tutorials from Redux store (loaded from API via fetchTutorials)
  return organization.tutorials || [];
}

/**
 * Memoized selector for tutorials for organization
 * Only recalculates when the organization changes
 */
export const tutorialsForOrganizationSelector = createSelector(
  [(state: State) => getOrganization(state)],
  (organization) => {
    if (!organization) return [];
    return tutorialsForOrganization(organization);
  },
);
